import { FETCH_END } from 'actions/fetchActions';
import {
  GET_META,
} from 'api/types';

const initialState = {};

export default resource => (previousState = initialState, { payload, meta}) => {
  if (!meta || meta.resource !== resource) {
    return previousState;
  }
  if (!meta.fetchResponse || meta.fetchStatus !== FETCH_END) {
    return previousState;
  }

  if (meta.fetchResponse === GET_META) {
    return payload.data
  }

  return previousState;
};




// WEBPACK FOOTER //
// ./src/reducers/resource/meta.js